var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"statusFixo":_vm.statusFixo,"statusModal":_vm.statusModal},on:{"changeTipo":_vm.changeTipo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }